import { render, staticRenderFns } from "./dataChart.vue?vue&type=template&id=1b40d236&scoped=true"
import script from "./dataChart.vue?vue&type=script&lang=js"
export * from "./dataChart.vue?vue&type=script&lang=js"
import style0 from "./dataChart.vue?vue&type=style&index=0&id=1b40d236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40d236",
  null
  
)

export default component.exports